// Tracker-layout export (plan §4 GET /exports/tracker, spec J8, F13). The workbook is a file, not
// JSON, so the client only builds the link: the browser downloads it with the session cookie from
// the portal's own origin, and the API checks the edition's permission on every download.
import type { Permission } from '@cis/shared';
import { API_BASE_PATH } from './http.ts';

export const EXPORT_EDITIONS = ['full', 'team'] as const;
export type ExportEdition = (typeof EXPORT_EDITIONS)[number];

/** The permission each edition needs, as the API's guard checks it (ROLE_PERMISSIONS). */
export const EXPORT_EDITION_PERMISSION: Readonly<Record<ExportEdition, Permission>> = {
  full: 'export.full',
  team: 'export.team',
};

/** Same-origin download link for one edition of the tracker export. */
export function trackerExportUrl(edition: ExportEdition, base = API_BASE_PATH): string {
  if (!(EXPORT_EDITIONS as readonly string[]).includes(edition)) {
    throw new RangeError('Unknown export edition');
  }
  return `${base}/exports/tracker?edition=${edition}`;
}
